import React, { useState, useEffect } from "react";
import axios, {AxiosRequestHeaders} from "axios";
import loaderimage from "../../images/giphy.gif";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface feedbacks {
  fId: number;
  userid: number | string;
  username: string;
  name: string;
  email: string;
  mobile: string;
  message: string;
  rating: number | string;
  isactive: number;
}

const Feedback = () => {
  const [feedback, setFeedbackList] = useState<feedbacks[]>([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [filteredFeedback, setFilteredFeedback] = useState<feedbacks[]>([]);
  const [searchTerm, setSearchTerm] = useState("");

   const headers: AxiosRequestHeaders = {
      'x-access-token': localStorage.getItem('jwttoken') || '',
    };
  

    const callApiFeedback = async () => {
      try {
        setLoader(true);
        setError(null);
        const url = process.env.REACT_APP_API_URL + "feedback/getFeedbacks";
        const response = await axios.get(url, { headers });
        setFeedbackList(response.data);
        setFilteredFeedback(response.data);
      } catch (error: any) {
        setError(error.message || "Failed to fetch feedback.");
        console.error("Error fetching feedback:", error);
        toast.error("Failed to load feedback");
      } finally {
        setLoader(false);
      }
    };

  useEffect(() => {
    callApiFeedback();
  }, []);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (searchTerm === "") {
        setFilteredFeedback(feedback);
      } else {
        const filtered = feedback.filter((item) =>
          item.name?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredFeedback(filtered);
      }
    }, 300);
    return () => clearTimeout(debounceTimeout);
  }, [searchTerm, feedback]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const getRatingStars = (rating: number | string) => {
    const numRating = Number(rating);
    return "⭐".repeat(numRating);
  };

  return (
    <>
      <div className="">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="text-black fw-bold">Feedback Management</h2>
          <div className="d-flex gap-2 align-items-center" style={{width:"510px"}}>
          <span className="fw-bold text-secondary text-nowrap">{filteredFeedback.length} results</span>
            <input
              type="text"
              className="form-control"
              placeholder="Search by Name"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
        </div>

        <div className="card shadow-sm border-0 rounded">
          <div className="card-header bg-info border-bottom py-3">
            <h5 className="mb-0 text-white">Feedback List</h5>
          </div>
          <div className="card-body p-0">
              <div
                className="table-responsive"
                style={{ maxHeight: "500px", overflowY: "auto" }}
              >
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light text-center">
                    <tr>
                      <th>#</th>
                      <th>User ID</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Message</th>
                      <th>Rating</th>
                    </tr>
                  </thead>
                  <tbody>
                  {loader ? ( 
                      <tr>
                        <td colSpan={7} className="text-center py-4">
                         <img src={loaderimage} alt="Loading..." height="40" />
                        </td>
                      </tr>
                    ) : error ? (
                      <tr>
                        <td colSpan={7} className="text-center text-danger fw-bold py-3">
                          <div className="alert alert-danger text-center m-3" role="alert">
                            Oops! Something went wrong. Please try again later.
                          </div>
                        </td>
                      </tr>
                    ) : filteredFeedback.length > 0 ? (
                      filteredFeedback.map((item, index) => (
                      <tr key={item.fId} className="border-bottom">
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{item.userid}</td>
                        <td>{item.name}</td>
                        <td>{item.email}</td>
                        <td>{item.mobile}</td>
                        <td>
                          <div
                            style={{
                              maxWidth: "300px",
                              whiteSpace: "pre-wrap",
                            }}
                          >
                            {item.message}
                          </div>
                        </td>
                        <td className="text-center">
                          <div className="text-warning">
                            {getRatingStars(item.rating)}
                          </div>
                          <small>({item.rating}/5)</small>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center text-muted fw-bold">
                        <div className="alert alert-secondary text-center m-3" role="alert">
                          No Feedback Available
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Feedback;
